<template>
  <div id="address-validation">
    <b-row no-gutters>
      <h1 class="mb-0">
        <strong>{{ $t('xAddressSearchVerifyAddressModalHeader') }}</strong>
      </h1>
    </b-row>
    <b-row no-gutters class="mb-2">
      <p>
        {{ modalDescriptionText }}
      </p>
    </b-row>
    <b-row v-if="submittedAddress">
      <b-card :title="$t('xAddressSearchProvidedAddress')" class="w-100 mx-3">
        <div class="address-with-icon">
          <i class="fa-regular fa-triangle-exclamation alertIcon"></i>
          <b-card-text class="address-spacing">
            <div>{{ `${submittedAddress.address1} ${submittedAddress.address2 ?? ''}`.trim() }}</div>
            <div>
              {{ `${submittedAddress.city}, ${submittedAddress.state} ${submittedAddress.postalCode}`.trim() }}
            </div>
            <div>{{ submittedAddress.country }}</div>
          </b-card-text>
        </div>
      </b-card>
    </b-row>
    <b-row v-if="shouldShowInvalidAddressScreen">
      <b-card :title="$t('xAddressSearchRecommendedAddressSingle')" class="w-100 mx-3 mt-2">
        <div class="address-with-icon">
          <i class="fa-regular fa-triangle-exclamation alertIcon"></i>
          <b-card-text class="address-spacing">
            {{ $t('xAddressNoRecommendedAddressFound') }}
          </b-card-text>
        </div>
      </b-card>
    </b-row>
    <b-row v-if="validateAddressResponse && validateAddressResponse.suggestionList && !shouldShowInvalidAddressScreen">
      <b-card :title="recommendedAddressLabel" class="w-100 mx-3 mt-2">
        <b-form-radio-group
          class="gap-4"
          v-model="selectedAddress"
          :options="addressOptions"
          name="address-options"
          stacked
        />
      </b-card>
    </b-row>
  </div>
</template>

<script>
export default {
  props: ['submittedAddress', 'validateAddressResponse'],
  emits: ['onSelect'],
  data() {
    return {
      selectedAddress: null
    }
  },
  computed: {
    addressOptions() {
      return this.validateAddressResponse.suggestionList.map(suggestion => ({
        value: suggestion,
        html: `<b-card-text>
              <div> ${suggestion.address1} ${suggestion.address2 ?? ''} </div>
              <div>
                 ${suggestion.city}, ${suggestion.state} ${suggestion.postalCode}
              </div>
              <div>${suggestion.countryCode}</div>
            </b-card-text>`
      }))
    },
    shouldShowInvalidAddressScreen() {
      return !this.validateAddressResponse?.isValidated && !this.validateAddressResponse?.suggestionList?.length
    },
    modalDescriptionText() {
      return this.shouldShowInvalidAddressScreen
        ? this.$t('xAddressSearchModalNoResultsBody')
        : this.$t('xAddressSearchModalSimilarFoundBody')
    },
    recommendedAddressLabel() {
      return this.validateAddressResponse?.suggestionList?.length === 1
        ? this.$t('xAddressSearchRecommendedAddressSingle')
        : this.$t('xAddressSearchRecommendedAddressPlural')
    }
  },
  watch: {
    validateAddressResponse(newVal) {
      if (newVal?.suggestionList?.length > 0) {
        this.selectedAddress = newVal.suggestionList[0] // automatically select first option
      } else {
        this.selectedAddress = null
      }
    },
    selectedAddress: {
      handler(newVal) {
        this.$emit('onSelect', newVal)
      }
    }
  },
  mounted() {
    if (this.validateAddressResponse?.suggestionList?.length > 0) {
      this.selectedAddress = this.validateAddressResponse.suggestionList[0]
    } else {
      this.selectedAddress = null
    }
  }
}
</script>
<style lang="scss">
#address-validation {
  .alertIcon {
    color: var(--yellow-400);
  }

  .address-spacing {
    line-height: 1.5rem;
  }

  // consistent spacing for warning icon addresses
  .address-with-icon {
    display: flex;
    align-items: center;
    padding-left: 0.5rem;

    .alertIcon {
      flex-shrink: 0;
      margin-right: 1rem;
      margin-top: 0.25rem; // align with first line of text
    }

    .address-spacing {
      flex: 1;
    }
  }

  // override radio button positioning
  .custom-control-input,
  .custom-control-label::after,
  .custom-control-label::before {
    top: 1.75rem !important; // 1 font size + .25 line height (above text) + .5 line height (between text)
  }

  // horizontal spacing of radio button
  .custom-control-label::after,
  .custom-control-label::before {
    left: -2rem !important;
  }

  // horizontal spacing of radio address text
  .custom-radio {
    padding-left: 2.5rem !important;

    &:not(:last-child) {
      margin-bottom: 1rem;
    }
  }
}
</style>
